//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPredictions } from '@/api/ai-tools.js';

export default {
  name: 'PredictionsPage',
  components: {
    Pagination: () => import('@motionelements/core/src/components/ui/BasePagination.vue'),
    PerPageSelect: () => import('@/components/predictions/PerPageSelect.vue'),
    PredictionsTable: () => import('@/components/predictions/PredictionsTable.vue'),
  },
  data() {
    return {
      predictions: [],
      isLoading: null,
      status: null,
      pagination: {
        totalCount: 0,
        currentPage: 1,
        perPage: 10,
      },
      //
      unwatch: null,
    };
  },
  computed: {
    routeQueryPerPage() {
      return _.get(this.$route.query, 'per_page');
    },
    routeQueryPage() {
      return _.get(this.$route.query, 'page');
    },
    params() {
      return {
        page: this.pagination.currentPage,
        per_page: this.pagination.perPage,
      };
    },
  },
  watch: {
    params(val, oldVal) {
      console.log('=============== WATCH params ', val, oldVal);
      this.updateRouteQuery({ ...this.$route.query, ...this.params });
    },
  },
  mounted() {
    this.parseQueryParams();
    this.getPredictions();
    //
    this.unwatch = this.$watch('$route.query', () => this.getPredictions());
  },
  beforeDestroy() {
    this.unwatch();
  },
  methods: {
    parseQueryParams() {
      if (this.routeQueryPerPage) this.pagination.perPage = +this.routeQueryPerPage;
      if (this.routeQueryPage) this.pagination.currentPage = +this.routeQueryPage;
    },
    async getPredictions() {
      this.isLoading = true;
      getPredictions({ ...this.params })
        .then(async response => {
          console.log(response);
          this.predictions = _.get(response, 'data.data');
          const data = _.get(response, 'data');
          this.pagination.totalCount = data.totalCount;
          this.isLoading = false;
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onChangePerPage(perPage) {
      this.pagination.currentPage = 1;
      this.pagination.perPage = perPage;
    },
    onChangePage(page) {
      this.pagination.currentPage = page;
    },
    updateRouteQuery() {
      this.$router.push({ query: { ...this.$route.query, ...this.params } });
    },
  },
};
